import React, { useCallback, useEffect } from 'react'
import TableCell from '@material-ui/core/TableCell'
import { HtmlToolTip } from 'assets/ToolTips'
import { getStyle } from 'assets/TableHeader'
import Typography from '@material-ui/core/Typography'
import { responseSummaryJoken } from 'types/ResponseTypes'
import { getTimestampFromNumber } from 'utils/dateUtil'
import { jokenTableSummary } from 'assets/TableHeader'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCell'
import { organismLog } from 'utils/logUtil'
import { useDispatch, useSelector } from 'react-redux'
import * as TableAction from 'actions/TableActions/TableJokenAction'
import * as SearchAction from 'actions/SearchActions/SearchJokenAction' // 共通部分が多いActionはActionCreaterにまとめる
import * as PageAction from 'actions/PageAction'
import { Link } from 'react-router-dom'
import { checkListSummary } from 'types/SearchTypes'
import { useUser } from 'hooks/useLogin'

const width = jokenTableSummary.width
const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

type Props = {
  joken: responseSummaryJoken
  isChecked: boolean
  no: number
}

const O_TableRowJoken = ({ joken, isChecked, no }: Props) => {
  useEffect(() => organismLog('O_TableRowJokenSummary'))
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.PageReducer.loading)
  const userKind = useUser()

  // 明細画面開示処理 //================================//
  const openDetail = useCallback(() => {
    if (!loading) {
      dispatch(PageAction.deleteMessage())
      dispatch(TableAction.clickJoken(joken.JOKEN_KANRI_NO))
      dispatch(SearchAction.openDetail(joken))
    }
  }, [loading])

  // チェック処理 //================================//
  const handleRowClick = useCallback((isChecked: boolean, joken: responseSummaryJoken) => {
    const data: checkListSummary = {
      JOKEN_KANRI_NO: joken.JOKEN_KANRI_NO,
      TOKUI_CD: joken.TOKUI_CD,
      JOTAI_KBN_0: joken.JOTAI_KBN_0,
      JOTAI_KBN_1: joken.JOTAI_KBN_1,
      JOTAI_KBN_2_1: joken.JOTAI_KBN_2_1,
    }
    dispatch(TableAction.checkJoken(isChecked, data))
  }, [])

  const TableData = (width: number | string, title: string, align: 'inherit' | 'left' | 'center' | 'right' | 'justify' | undefined, click: React.MouseEventHandler<HTMLSpanElement>) => {
    return (
      <TableCell style={getStyle(width)} align={align}>
        <HtmlToolTip
          title={
            <Typography variant="caption" color="inherit">
              {title}
            </Typography>
          }
        >
          <Typography variant="caption" onClick={click}>
            <Link to={loading ? `hanJoken` : `hanJoken/${title}`}>{title}</Link>
          </Typography>
        </HtmlToolTip>
      </TableCell>
    )
  }

  return (
    <>
      {/* No */}
      <M_TableCell category="number" data={no} width={width.NO} />
      {/* チェックボックス */}
      <M_TableCell category="checkbox" isChecked={isChecked} width={width.CHECK} click={() => handleRowClick(isChecked, joken)} />
      {/* 状態 */}
      <M_TableCell
        category="data" //
        width={width.JOTAI}
        align={'left'}
        title={joken.JOTAI}
        data={joken.JOTAI}
      />
      {
        /* 上長承認状態 */
        userKind === 0 ? (
          <M_TableCell
            category="data" //
            width={width.JOCHO_JOTAI}
            align={'left'}
            title={joken.JOCHO_JOTAI}
            data={joken.JOCHO_JOTAI}
          />
        ) : (
          <></>
        )
      }
      {/* 管理No */}
      {TableData(width.KANRI_NO, joken.JOKEN_KANRI_NO, 'left', openDetail)}
      {/* 件名 */}
      <M_TableCell
        category="data" //
        width={width.KEN}
        align={'left'}
        title={joken.KEN_NM}
        data={joken.KEN_NM}
        blackout={manualMode}
      />
      {/* 適用期間(開始) */}
      <M_TableCell
        category="data" //
        width={width.STRT_DT}
        align={'left'}
        title={getTimestampFromNumber(joken.TEKIYO_START_DT, '/')}
        data={getTimestampFromNumber(joken.TEKIYO_START_DT, '/')}
        blackout={manualMode}
      />
      {/* 適用期間(終了) */}
      <M_TableCell
        category="data" //
        width={width.END_DT}
        align={'left'}
        title={getTimestampFromNumber(joken.TEKIYO_END_DT, '/')}
        data={getTimestampFromNumber(joken.TEKIYO_END_DT, '/')}
        blackout={manualMode}
      />
      {/* 事業所 */}
      <M_TableCell
        category="data" //
        width={width.JIGYO}
        align={'left'}
        title={joken.JIGYO_CD === 0 ? '全国' : joken.JIGYO_NM}
        data={joken.JIGYO_NM}
        blackout={manualMode}
      />
      {/* 全国 */}
      <M_TableCell
        category="data" //
        width={width.ZENKOKU}
        align={'left'}
        title={joken.ZENKOKU_KBN === 1 ? '全国' : ''}
        data={joken.ZENKOKU_KBN === 1 ? '全国' : ''}
        blackout={manualMode}
      />
      {/* 課 */}
      <M_TableCell
        category="data" //
        width={width.BUSHO}
        align={'left'}
        title={joken.BUSHO_NM}
        data={joken.BUSHO_NM}
        blackout={manualMode}
      />
      {/* 得意先 */}
      <M_TableCell
        category="data" //
        width={width.TOKUI}
        align={'left'}
        title={joken.TOKUI_NM}
        data={joken.TOKUI_NM}
        blackout={manualMode}
      />
      {/* 仕入先 */}
      <M_TableCell
        category="data" //
        width={width.SIIRE}
        align={'left'}
        title={joken.SIIRE_NM}
        data={joken.SIIRE_NM}
        blackout={manualMode}
      />
      {/* 担当者 */}
      <M_TableCell
        category="data" //
        width={width.TANTO}
        align={'left'}
        title={joken.TANTO_NM}
        data={joken.TANTO_NM}
        blackout={manualMode}
      />
      {
        /* 入力担当者 */
        userKind === 0 ? (
          <M_TableCell
            category="data" //
            width={width.ADD_TANTO}
            align={'left'}
            title={joken.ADD_TANTO_NM}
            data={joken.ADD_TANTO_NM}
            blackout={manualMode}
          />
        ) : (
          <></>
        )
      }
    </>
  )
}

export default React.memo(O_TableRowJoken)
